import request from '@/utils/seftRequest';

// 查询客户存在 /drm/ding/custService/checkCustExists
export function qryCustExist(data) {
  return request('/ding/custService/checkCustExists', {
    method: 'POST',
    body: data,
  });
}
